import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { tenantService } from '@/services/http/tenantService'

export const useGetAllTennants = () => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['tennants'],
    queryFn: () => tenantService.getTennants(),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao buscar tenants',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    const { tennants } = data
    return {
      tennants,
      isLoading,
      refetchTennants: refetch,
    }
  }

  return {
    tennants: [],
    isLoading,
    refetchTennants: refetch,
  }
}
